import React, { useEffect, useRef, useState } from "react"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import { nanoid } from "nanoid"
import { Avatar } from "@mui/material"
import "./MainApp.css"
import logo from "../ahk.png"
import Loading from "./Loading"
import SignOutButton from "./SignOutButton"

interface Item {
  id: string
  question: string
  response: string
}

interface OpenAIInput {
  prompt: string
  format: string
}

interface OpenAIOutput {
  answer: string
}

const MainApp: React.FC = () => {
  const [question, setQuestion] = useState<string>("")
  const [showChat, setShowChat] = useState<Item[]>([])
  const [tempQuestion, setTempQuestion] = useState<string>("")
  const [isLoading, setIsLoading] = useState(false)
  const [isTimeOut, setIsTimeOut] = useState(false)

  //aplying useRef with useEffect to position focus on the input after showchat statevalue updates
  const chatRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }, [isLoading, showChat])

  const getAnswer = async (
    url: string,
    data: OpenAIInput
  ): Promise<OpenAIOutput> => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`)
    }

    return response.json()
  }

  // const handleQuestionSubmit = async () => {
  //   const tempRes =
  //     "<p>La Ley 81 de <strong>Panamá</strong> es la legislación que establece el régimen general de protección de datos personales. Su principal objetivo es regular los principios, derechos, obligaciones y procedimientos que gobiernan la protección de los datos personales de las personas naturales en la República de Panamá. Esta ley reconoce la inviolabilidad de las comunicaciones privadas y el derecho de toda persona a acceder a su información personal que esté contenida en bases de datos o registros tanto públicos como privados. Además, garantiza el derecho a requerir la rectificación, protección y supresión de sus datos personales, de acuerdo con lo establecido por la ley.</p><p>La Ley 81 de 2019 establece un marco legal para defender el derecho a la protección de datos personales y se considera el estándar mínimo de cumplimiento en relación con esta protección para cualquier ley especial en la materia y para cualquier entidad reguladora en Panamá.</p><p>La Ley 81 entró en vigor el 29 de marzo de 2021 y es regulada por la Autoridad Nacional de Transparencia y Acceso a la Información (ANTAI), que tiene la responsabilidad de supervisar su implementación y asegurar el cumplimiento de sus disposiciones. Las reglas que establece la ley y los decretos asociados son aplicables a cualquier tratamiento de datos personales, con ciertas adaptaciones y requisitos adicionales en el caso de leyes especiales o tratamientos de datos en actividades reguladas.</p><p>De acuerdo a lo establecido en el Decreto Ejecutivo N° 285 de 2021, la ley y sus decretos resultan aplicables cuando las bases de datos se encuentran en el territorio de Panamá y almacenan datos de nacionales o extranjeros, cuando el responsable del tratamiento de datos está domiciliado en el país, o cuando se lleven a cabo tratamientos de datos cuyo origen o almacenamiento sea en el territorio panameño, incluidas las actividades comerciales por Internet dirigidas al mercado panameño.</p>"
  //   setIsTimeOut(false)
  //   setIsLoading(true)
  //   setTempQuestion(question)
  //   setQuestion("")
  //   setTimeout(() => {
  //     setShowChat([
  //       ...showChat,
  //       {
  //         id: nanoid(),
  //         question: question,
  //         response: tempRes,
  //       },
  //     ])

  //     setIsLoading(false)
  //   }, 5000)
  // }

  const handleQuestionSubmit = async () => {
    setIsLoading(true)
    setIsTimeOut(false)

    setTempQuestion(question)
    setQuestion("") // Clear the question after submitting

    try {
      getAnswer("https://ley-81-api.ahinko.com/get_answer", {
        format: "html",
        prompt: question,
      })
        .then((data) => {
          console.log("Got Response")
          console.log(data.answer)

          setIsLoading(false)
          setShowChat([
            ...showChat,
            { id: nanoid(), question: question, response: data.answer },
          ])
        })
        .catch((error) => {
          console.error("There was an error!", error)
          setIsLoading(false)
          setIsTimeOut(true)
          setQuestion(question)
        })
    } catch (error) {
      console.error("Error calling OpenAI:", error)
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault() // Prevent the default action to avoid form submission if inside a form
      handleQuestionSubmit()
    }
  }

  return (
    <div className="container" style={{ margin: "20px" }}>
      <SignOutButton />
      <br />
      <div className="welcome-text-container" style={{ padding: "0 20px" }}>
        <Avatar src={logo} alt="ahinko logo" sx={{ width: 48, height: 48 }} />

        <h3 className="welcome-text">
          Hola, Soy tu asistente virtual aquí para ayudarte a entender todo
          sobre las leyes 81 y 23 de Panamá. Puedo interpretar tus preguntas escritas en
          lenguaje natural, así que siéntete libre de preguntarme cualquier cosa
          relacionada con estas leyes. ¡Estoy aquí para ayudarte!
        </h3>
      </div>
      <div className="chat-container">
        {
          // response &&
          showChat.map((item, index) => {
            const myHTML: { __html: string } = {
              __html: item.response,
            }
            return (
              <div
                key={item.id}
                style={{
                  // marginTop: "20px",
                  padding: "20px",
                  // border: "1px solid #ccc",
                }}
              >
                <div className="chat-question">
                  <Avatar sx={{ width: 24, height: 24 }} />
                  <div
                    className="question-text"
                    ref={index === showChat.length - 1 ? chatRef : null}
                  >
                    <strong>Tu: </strong>
                    <p> {item.question} </p>
                  </div>
                </div>
                <div className="chat-response">
                  <Avatar
                    src={logo}
                    alt="ahinko logo"
                    sx={{ width: 24, height: 24 }}
                  />
                  <div className="response-text">
                    <strong>Respuesta: </strong>
                    <p dangerouslySetInnerHTML={myHTML}></p>
                  </div>
                </div>
              </div>
            )
          })
        }

        {isLoading && (
          <div
            style={{
              padding: "20px",
            }}
          >
            <div className="chat-question">
              <Avatar sx={{ width: 24, height: 24 }} />
              <div className="question-text" ref={chatRef}>
                <strong>Tu: </strong>
                <p> {tempQuestion} </p>
              </div>
            </div>
            <div className="chat-response">
              <Avatar
                src={logo}
                alt="ahinko logo"
                sx={{ width: 24, height: 24 }}
              />
              <div className="response-text">
                <strong>Respuesta: </strong>
              </div>
            </div>
            <Loading isLoading={isLoading} />
          </div>
        )}

        {isTimeOut && (
          <div
            style={{
              padding: "20px",
            }}
          >
            <div className="chat-question">
              <Avatar sx={{ width: 24, height: 24 }} />
              <div className="question-text" ref={chatRef}>
                <strong>Tu: </strong>
                <p> {tempQuestion} </p>
              </div>
            </div>
            <div className="chat-response">
              <Avatar
                src={logo}
                alt="ahinko logo"
                sx={{ width: 24, height: 24 }}
              />
              <div className="response-text">
                <strong>Respuesta: </strong>
              </div>
            </div>
            <div className="timeout-message">
              <p className="timeout-text">
                El tiempo de espera para respuesta expiró
              </p>
              <Button
                variant="outlined"
                onClick={handleQuestionSubmit}
                style={{ borderRadius: "18px" }}
              >
                Reintentar
              </Button>
            </div>
          </div>
        )}
      </div>
      <TextField
        label="Hazme una pregunta"
        variant="outlined"
        fullWidth
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        onKeyDown={handleKeyDown}
        className="text-input"
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleQuestionSubmit}
        style={{ marginTop: "20px", marginBottom: "20px" }}
        className="btn"
      >
        Preguntar
      </Button>
    </div>
  )
}

export default MainApp
